import.meta.glob(['../img/**',]);

import './scripts/accordion.js';
// import './scripts/sliders.js';

import './scripts/navigation.js';
// import './scripts/contact-form.js';
import '@awesome.me/webawesome/dist/components/comparison/comparison.js';

import './scripts/forms.js';

import './scripts/load-more.js';



if (document.querySelectorAll('.js-player').length > 0){
    import('./scripts/custom-video-player.js').then(({initPlyr}) => initPlyr())
}

window.addEventListener('load', () => {
    if (document.querySelectorAll('.block-testimonials').length > 0) {
        import('./scripts/testimonials.js').then(({initTestimonialsSlider}) => initTestimonialsSlider());
    }
});

function setScrollbarWidth() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth + 1;// added + 1 so if clientWidth is with . something it will still calculate properly.
    document.documentElement.style.setProperty('--scrollbar-size', `${scrollbarWidth}px`);
}

setScrollbarWidth()


const heroVideo = document.getElementById('_js-hero-video');
if (heroVideo) {

    const heroVideoSource = document.getElementById('hero-video-source');

    const desktopVideoSource = heroVideo.dataset.desktopVideo;
    const mobileVideoSource = heroVideo.dataset.mobileVideo;


    function setHeroVideo() {
        const isMobile = window.innerWidth <= 768;

        const newSrc = isMobile ? mobileVideoSource : desktopVideoSource;
        if (heroVideoSource.src !== newSrc) {
            heroVideoSource.src = newSrc;
            heroVideo.load();
        }
    }


    setHeroVideo()
    window.addEventListener('resize', setHeroVideo)
}



document.querySelectorAll('.policy-page ol[start]').forEach(ol => {
    const start = parseInt(ol.getAttribute('start'), 10);
    if (!isNaN(start)) {
        ol.style.counterReset = `list-counter ${start - 1}`;
    }
});